import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";

export default function FloatingPanelWindow({
  visible = true,
  onMouseDown,
  position = { x: 12, y: 12 },
  width = 620,
  zIndex = 1500,
  title = "",
  onHeaderMouseDown,
  headerCursor = "default",
  actions,
  children,
  bodyPadding = 1.25,
  bodyMaxHeight = "72vh",
  compactFields = true,
}) {
  if (!visible) {
    return null;
  }

  return (
    <Paper
      elevation={8}
      onMouseDown={onMouseDown}
      sx={{
        position: "fixed",
        left: { xs: 12, md: position.x },
        top: { xs: 12, md: position.y },
        zIndex,
        width: { xs: "calc(100vw - 24px)", md: width },
        maxWidth: "calc(100vw - 24px)",
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
        overflow: "hidden",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        onMouseDown={onHeaderMouseDown}
        sx={{
          px: 1.25,
          py: 0.9,
          borderBottom: "1px solid",
          borderColor: "divider",
          backgroundColor: "#f5f8fa",
          cursor: headerCursor,
          userSelect: "none",
        }}
      >
        <Typography variant="subtitle2" color="text.secondary">
          {title}
        </Typography>
        <Stack direction="row" spacing={0.5}>
          {actions}
        </Stack>
      </Stack>

      <Box
        sx={{
          p: bodyPadding,
          maxHeight: bodyMaxHeight,
          overflow: "auto",
          ...(compactFields
            ? {
                "& .MuiTextField-root": {
                  "& .MuiInputLabel-root": {
                    fontSize: 12,
                  },
                  "& .MuiInputBase-root": {
                    minHeight: 34,
                    fontSize: 12,
                  },
                  "& .MuiInputBase-input": {
                    py: 0.65,
                  },
                },
              }
            : {}),
        }}
      >
        {children}
      </Box>
    </Paper>
  );
}

export function FloatingPanelDock({
  label,
  onRestore,
  onClose,
  indicatorColor,
  zIndex = 1600,
}) {
  return (
    <Paper
      elevation={6}
      sx={{
        px: 0.75,
        py: 0.45,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 1.5,
        backgroundColor: "#ffffff",
        zIndex,
      }}
    >
      <Stack direction="row" spacing={0.5} alignItems="center">
        {indicatorColor ? (
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: indicatorColor,
              flexShrink: 0,
            }}
          />
        ) : null}
        <Typography
          variant="caption"
          sx={{
            maxWidth: 150,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontWeight: 600,
          }}
        >
          {label}
        </Typography>
        <IconButton size="small" onClick={onRestore}>
          <ArrowDropUpIcon fontSize="small" />
        </IconButton>
        <IconButton size="small" onClick={onClose}>
          <CloseOutlinedIcon fontSize="small" />
        </IconButton>
      </Stack>
    </Paper>
  );
}

export function FloatingPanelDockTray({
  children,
  zIndex = 1600,
  right = 12,
  bottom = 12,
}) {
  return (
    <Box
      sx={{
        position: "fixed",
        right,
        bottom,
        zIndex,
        display: "flex",
        gap: 1,
        flexWrap: "wrap",
        justifyContent: "flex-end",
        maxWidth: "calc(100vw - 24px)",
      }}
    >
      {children}
    </Box>
  );
}
